import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
  makeStyles,
  TextField,
} from "@material-ui/core";
import {
  CircularProggressIndicator,
  OrderRejectButton,
  TrigerPrint,
} from "../components-atoms";
import { useTranslation } from "react-i18next";
import {
  NumberOfPackageSelectionModal,
  OrderCancelledModal,
  OrderDetailsBasicInfoSection,
  OrderDetailsCustomerInformationSection,
  OrderDetailsHeaderSection,
  OrderDetailsOrderedItemsSection,
  PrintLabelsAgainComponent,
  PrintableItemList,
  QRPrintableComponent,
  RejectItemModal,
  RejectOrderModal,
  OrderDetailsMerchantInfoSection,
  OrderDetailsDriverInfoSection,
  ResolveDeliverySelectionModal,
  OrderDetailsFailureWarning,
} from "../components-molecules";
import {
  clearAcknowledgeCancellation,
  getAcknowledgeCancellation,
} from "../redux/actions/acknowledgeCancellation";
import {
  clearDeliveryHasCancellation,
  getDeliveryHasCancellation,
} from "../redux/actions/deliveryHasCancellation";
import {
  clearOrderChangeQuantity,
  getOrderChangeQuantity,
} from "../redux/actions/orderChangeQuantity";
import {
  clearOrderDetails,
  getOrderDetails,
  goBackToOrdersList,
} from "../redux/actions/orderDetails";
import { clearRejectOrder } from "../redux/actions/rejectOrder";
import {
  clearMerchantInfo,
  getMerchantInfo,
} from "../redux/actions/getMerchantInfo";
import { getDriverInfo } from "../redux/actions/getDriverInfo";
import {
  clearResetQuantity,
  getResetQuantity,
} from "../redux/actions/resetQuantity";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import { is_able_to, roleName } from "../utils/roles";
import { useReactToPrint } from "react-to-print";
import {
  clearResolveFailedDelivery,
  getResolveFailedDelivery,
} from "../redux/actions/resolveFailedDelivery";
import { NoItemLeftModal } from "../components-molecules/NoItemLeftModal";
import { OrderDetailsHistorySection } from "../components-molecules/OrderDetailsHistorySection";
import { InfoSectionContainer } from "../components-molecules/InfoSectionContainer";
import { Controller, useForm } from "react-hook-form";
import {
  VehicleTypeSelector,
  VehicleTypeSource,
} from "../components-molecules/VehicleTypeSelector";
import {
  acceptOrkestroOrder,
  rejectOrkestroOrder,
} from "../redux/actions/orders";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import Block from "@material-ui/icons/Block";
import { theme } from "../constants/theme";
import { InfoSection } from "../components-molecules/InfoSection";
import { DeliveryAlreadyProcessedModal } from "../components-molecules/DeliveryAlreadyProcessedModal";
import { DeliveryAlreadyProcessedException } from "../utils/deliveryUtil";

var intervalNumber: any;
const requestDuration = 30000;
export const OrderDetails = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const params: any = useParams();
  const qrSectionRef = useRef(null!);
  const qrSectionPrintAgainRef = useRef(null!);
  const itemListRef = useRef(null!);
  const [intervalId, setIntervalId] = useState<any>();
  const dispatch = useDispatch();
  const role = useSelector((state: any) => state.login.role);

  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  useEffect(() => {
    requestOrderDetails(itemId);

    return () => {
      dispatch(clearOrderDetails());
      dispatch(clearAcknowledgeCancellation());
      dispatch(clearResetQuantity());
      dispatch(clearOrderChangeQuantity());
      dispatch(clearRejectOrder());
      clearInterval(intervalNumber);
      clearInterval(intervalId);
    };
  }, []); // eslint-disable-line

  const orderDetailsLoading = useSelector(
    (state: any) => state.orderDetails.loading,
  );
  const data = useSelector((state: any) => state.orderDetails.data);
  const deliveryAcceptData = useSelector(
    (state: any) => state.deliveryAccept.data,
  );
  const rePrintPackagesInfo = useSelector((state: any) => state.packages.data);
  const itemId = params.id;
  const deliveryAccepted = useSelector(
    (state: any) => state.deliveryAccept.data,
  );
  const deliveryAcceptedError = useSelector(
    (state: any) => state.deliveryAccept.error,
  );
  const orderChangeQuantityData = useSelector(
    (state: any) => state.orderChangeQuantity.data,
  );
  const resetQuantityData = useSelector(
    (state: any) => state.resetQuantity.data,
  );

  const resolveFailedDeliveryData = useSelector(
    (state: any) => state.resolveFailedDelivery.data,
  );
  const rejectOrderData = useSelector((state: any) => state.rejectOrder.data);
  const [rejectOrderModalVisible, setRejectOrderModalVisible] = useState(false);
  const [rejectItemModalVisible, setRejectItemModalVisible] = useState(false);
  const [noItemLeftModalVisible, setNoItemLeftModalVisible] = useState(false);
  const [alreadyProcessedModalVisible, setAlreadyProcessedModalVisible] =
    useState(false);
  const [orderLineQuantity, setOrderLineQuantity] = useState();
  const [orderlineDetails, setOrderlineDetails] = useState<any>({});
  const [resolveDeliveryModalVisible, setResolveDeliveryModalVisible] =
    useState(false);
  const deliveryHasCancellation = useSelector(
    (state: any) => state.deliveryHasCancellation.data,
  );
  const acknowledgeCancellationData = useSelector(
    (state: any) => state.acknowledgeCancellation.data,
  );
  const [wholeDeliveryCancelled, setWholeDeliveryCancelled] = useState(false);
  const [acknowledgementRequestId, setAcknowledgementRequestId] = useState("");
  const [displayHasCancellationModal, setDisplayHasCancellationModal] =
    useState(false);
  const [afterHasCancellationCheck, setAfterHasCancellationCheck] =
    useState("");
  const [merchantInfo, driverInfo] = useSelector((state: any) => [
    state.GetMerchantInfoReducer.data,
    state.GetDriverInfoReducer.data,
  ]);
  const activeOrders = useMemo(
    () => data.Orderlines?.filter((o) => o.OrderLineQuantity > 0),
    [data.Orderlines],
  );
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    if (data.length !== 0) {
      if (data.Cancelled === null && intervalId === undefined) {
        let interval = setInterval(() => {
          if (!displayHasCancellationModal) {
            clearDeliveryHasCancellation();
            dispatch(getDeliveryHasCancellation(itemId));
          }
        }, requestDuration);
        intervalNumber = interval;
        setIntervalId(interval);
      }

      if (afterHasCancellationCheck === "list") {
        setAfterHasCancellationCheck("");
        setPrintItemList(true);
        setTimeout(() => {
          setPrintItemList(false);
        }, 100);
      }
    }
  }, [data]); // eslint-disable-line

  useEffect(() => {
    if (deliveryHasCancellation.DeliveryHasCancelRequest) {
      setWholeDeliveryCancelled(deliveryHasCancellation.WholeDelivery);
      setAcknowledgementRequestId(
        deliveryHasCancellation.AcknowledgementRequestId,
      );
      setDisplayHasCancellationModal(true);
    } else {
      if (afterHasCancellationCheck !== "") {
        switch (afterHasCancellationCheck) {
          case "list":
            requestOrderDetails(itemId);
            break;
          default:
            break;
        }
      }
    }
  }, [deliveryHasCancellation]); // eslint-disable-line
  useEffect(() => {
    if (acknowledgeCancellationData === "Acknowledged") {
      setAfterHasCancellationCheck("");
      requestOrderDetails(itemId);
      setDisplayHasCancellationModal(false);
      dispatch(clearAcknowledgeCancellation());
    }
  }, [acknowledgeCancellationData]); // eslint-disable-line
  const onAcknowledgePressed = () => {
    dispatch(getAcknowledgeCancellation(itemId, acknowledgementRequestId));
  };
  useEffect(() => {
    if (
      Array.isArray(deliveryAccepted) &&
      deliveryAccepted.length > 0 &&
      typeof deliveryAccepted !== "string" &&
      deliveryAcceptedError !== true
    ) {
      setPrint(true);
      setTimeout(() => {
        setPrint(false);
      }, 100);
    } else {
      requestOrderDetails(itemId);
    }
  }, [deliveryAccepted]); // eslint-disable-line
  useEffect(() => {
    if (Object.keys(orderChangeQuantityData).length > 0) {
      requestOrderDetails(itemId);
    }
  }, [orderChangeQuantityData]); // eslint-disable-line
  useEffect(() => {
    if (Object.keys(resetQuantityData).length > 0) {
      requestOrderDetails(itemId);
    }
  }, [resetQuantityData]); // eslint-disable-line
  useEffect(() => {
    if (Object.keys(rejectOrderData).length > 0) {
      setRejectOrderModalVisible(false);
      requestOrderDetails(itemId);
    }
  }, [rejectOrderData]); // eslint-disable-line
  useEffect(() => {
    if (resolveFailedDeliveryData === "Delivery Recovered") {
      dispatch(clearResolveFailedDelivery());
      requestOrderDetails(itemId);
    }
  }, [resolveFailedDeliveryData]); // eslint-disable-line

  useEffect(() => {
    CheckNoItemLeftModal();
  }, [data.Orderlines]); // eslint-disable-line

  const [numberOfPackageModalVisible, setNumberOfPackageModalVisible] =
    useState(false);
  const [, setEnterPackageNumber] = useState(true);
  const [, setNrOfPackages] = useState("");
  const [print, setPrint] = useState(false);
  const [printAgain] = useState(false);
  const [printItemList, setPrintItemList] = useState(false);

  const PackagesSelected = (packages: any) => {
    setNrOfPackages(packages);
    setEnterPackageNumber(false);
    setNumberOfPackageModalVisible(false);
  };

  const requestOrderDetails = (id: string) => {
    dispatch(clearMerchantInfo());
    dispatch(
      getOrderDetails(id, (resp: any) => {
        const orderNo = resp.Result.OrderNo;
        const shopName = resp.Result.ShopName;
        const defaultPickupInstructions = `Please collect TRADEKART order number TK${orderNo} - ${shopName}.`;
        setValue("PickupInstructions", defaultPickupInstructions);

        dispatch(getMerchantInfo(resp.Result.ShopId));
        if (resp.Result.DriverId) {
          dispatch(getDriverInfo(resp.Result.DriverId));
        }
      }),
    );
  };
  const PrintLabels = useReactToPrint({
    content: () => qrSectionRef.current,
    pageStyle: printablePageStyle,
    onAfterPrint: () => requestOrderDetails(itemId),
  });
  const PrintLabelsAgain = useReactToPrint({
    content: () => qrSectionPrintAgainRef.current,
    pageStyle: printablePageStyle,
    onAfterPrint: () => requestOrderDetails(itemId),
  });
  /*
  const PrintLabelsClicked = () => {
    setAfterHasCancellationCheck("label");
    clearDeliveryHasCancellation();
    dispatch(getDeliveryHasCancellation(itemId));
  };
  */
  const PrintItemListClicked = () => {
    setAfterHasCancellationCheck("list");
    clearDeliveryHasCancellation();
    dispatch(getDeliveryHasCancellation(itemId));
  };
  const PrintItemList = useReactToPrint({
    content: () => itemListRef.current,
  });
  /*
  const PrintLabelsAgainClicked = () => {
    setPrintAgain(true);
    setTimeout(() => {
      setPrintAgain(false);
    }, 100);
  };
  */

  const AcceptOrderButtonPressed = () => {
    setActionLoading(true);
    const { VehicleTypeId, PickupInstructions } = getValues();
    acceptOrkestroOrder(
      {
        VehicleTypeId: VehicleTypeId,
        DeliveryId: itemId,
        PickupInstructions: PickupInstructions || undefined,
      },
      (res) => {
        setActionLoading(false);
        requestOrderDetails(itemId);
      },
      (err) => {
        if (err === DeliveryAlreadyProcessedException) {
          setAlreadyProcessedModalVisible(true);
        }
        setActionLoading(false);
      },
    );
  };

  const RejectOrderButtonPressed = () => {
    setRejectOrderModalVisible(true);
  };
  const ResolveButtonPressed = () => {
    setResolveDeliveryModalVisible(true);
  };
  const ResolveDeliveryConfirmPressed = (resolveAction: string) => {
    // TODO: Resolve delivery logic
    let action = "";
    switch (resolveAction) {
      case "Delivered":
        action = "delivered";
        break;
      case "Refunded":
        action = "refunded";
        break;
      default:
        break;
    }
    dispatch(getResolveFailedDelivery(data.Id, action));

    setResolveDeliveryModalVisible(false);
  };

  const RefundDeliveredDelivery = () => {
    dispatch(getResolveFailedDelivery(data.Id, "refunded"));
  };

  const RejectOrderConfirmButtonPressed = () => {
    setActionLoading(true);
    setRejectOrderModalVisible(false);
    setNoItemLeftModalVisible(false);
    rejectOrkestroOrder(
      data.Id,
      () => {
        window.location.reload();
      },
      (err) => {
        setActionLoading(false);
        if (err === DeliveryAlreadyProcessedException) {
          setAlreadyProcessedModalVisible(true);
        }
      },
    );
  };
  const RejectItemButtonPressed = (item: any) => {
    setOrderLineQuantity(item.OrderLineQuantity);
    setOrderlineDetails(item);
    setRejectItemModalVisible(true);
  };
  const RejectItemConfirmButtonPressed = (quantity: any) => {
    const orderLineId = orderlineDetails?.OrderLineId;
    dispatch(getOrderChangeQuantity(data.Id, orderLineId, quantity));
    setRejectItemModalVisible(false);
  };
  const RejectItemModalClose = () => {
    setOrderLineQuantity(undefined);
    setOrderlineDetails(null);
    setRejectItemModalVisible(false);
  };
  const ResetQuantityPressed = (item: any) => {
    dispatch(getResetQuantity(data.Id, item.OrderLineId));
  };

  const onBackClicked = () => {
    if (data.Rejected || data.Cancelled || data.Failed || data.Returned) {
      goBackToOrderList();
      return;
    }

    dispatch(
      goBackToOrdersList(data.Id, (res: any) => {
        if (res.Result) {
          setNoItemLeftModalVisible(true);
        } else {
          goBackToOrderList();
        }
      }),
    );
  };
  const goBackToOrderList = () => {
    switch (roleName()) {
      case "Admin":
        history.push("/admin/orders");
        break;
      case "Merchant":
        history.push("/merchant/orders");
        break;

      default:
        history.push("/orders");
        break;
    }
  };

  // If there is no active item left
  // and order not rejected or cancelled
  const CheckNoItemLeftModal = () => {
    if (activeOrders?.length === 0 && !data.Rejected && !data.Cancelled) {
      const activeOrders = data.Orderlines.filter(
        (o) => o.OrderLineQuantity > 0,
      );

      if (activeOrders.length <= 1) {
        setNoItemLeftModalVisible(true);
      }
    }
  };

  const NoItemLeftModalClose = () => {
    setNoItemLeftModalVisible(false);
  };

  const renderTrackingInfo = useCallback(
    () => (
      <InfoSection
        title={t("orderDetails.trackingInformation")}
        sx={{ mb: 2 }}
        data={[
          {
            title: t("orderDetails.url"),
            href: data.DeliveryTrackingUrl,
          },
        ]}
      />
    ),
    [data.DeliveryTrackingUrl, t],
  );

  const renderPickupInstructions = () => {
    if (data.ShopPortalStatus !== "Pending") {
      return <></>;
    }
    if (!is_able_to("reject_orders")) {
      return <></>;
    }
    return (
      <InfoSectionContainer
        title={t("orderDetails.pickupInstructions")}
        helperText={t("orderDetails.pickupInstructionsHelper")}
        sx={{ mt: 3, mb: 3 }}
      >
        <Controller
          name="PickupInstructions"
          control={control}
          render={({ field: { ref, value, ...rest } }) => (
            <TextField
              {...rest}
              value={value || ""}
              inputRef={ref}
              multiline
              minRows={1}
              placeholder={t("orderDetails.enterPickupInstructions")}
              inputProps={{ maxLength: 100 }}
              helperText={`${(value || "").length}/100`}
              style={{
                marginTop: 12,
              }}
            />
          )}
        />
      </InfoSectionContainer>
    );
  };

  const renderVehicleType = () => {
    if (data.ShopPortalStatus !== "Pending") {
      return <></>;
    }
    if (!is_able_to("reject_orders")) {
      return <></>;
    }
    return (
      <InfoSectionContainer
        title={t("orderDetails.vehicleType")}
        helperText={t("orderDetails.vehicleTypeHelper")}
        sx={{ mt: 3 }}
      >
        <Controller
          name="VehicleTypeId"
          control={control}
          rules={{ required: t("orderDetails.pleaseSelectVehicleType") }}
          render={({ field: { ref, ...rest } }) => (
            <>
              <VehicleTypeSelector
                source={VehicleTypeSource.TK_ORDER}
                style={{
                  marginTop: 12,
                  marginBottom: errors.VehicleTypeId ? 12 : 0,
                }}
                hasError={Boolean(errors.VehicleTypeId)}
                suggestedVehicleType={data.MinimumRequiredVehicle}
                {...rest}
              />
              {errors.VehicleTypeId && (
                <Typography variant="caption" color="error">
                  {errors.VehicleTypeId.message}
                </Typography>
              )}
            </>
          )}
        />
      </InfoSectionContainer>
    );
  };

  const showCheckErrorsModal = () => {
    return <></>;
    // return (
    //   <ConfirmModal
    //     title={checkErrorTitle}
    //     visible={Boolean(showKarterPopup)}
    //     buttonTitle={buttonTitle}
    //     customBody={() => modalBody()}
    //     onClose={onCloseErrorModal}
    //     onSubmit={onSubmitErrorModal}
    //     cancelButtonVisible={Boolean(false)}
    //   />
    // );
  };

  const renderActionButtons = () => {
    return (
      <Grid className={classes.actionButtonsContainer}>
        {data.ShopPortalStatus !== "Pending" ? (
          <></>
        ) : (
          is_able_to("reject_orders") && (
            <OrderRejectButton
              title={t("orderDetails.reject")}
              onClick={RejectOrderButtonPressed}
              disabled={actionLoading}
              startIcon={
                <Grid className={classes.startIconStyle}>
                  {actionLoading ? (
                    <CircularProgress
                      size="18px"
                      style={{ color: "rgba(0, 0, 0, 0.54)" }}
                    />
                  ) : (
                    <Block style={{ fontSize: "18px" }} />
                  )}
                </Grid>
              }
            />
          )
        )}
        {data.ShopPortalStatus !== "Pending" ? (
          <></>
        ) : (
          is_able_to("reject_orders") && (
            <Button
              data-automation="accept-button"
              variant="contained"
              style={{
                backgroundColor: actionLoading
                  ? theme.palette.success.light
                  : theme.palette.success.main,
                color: "white",
              }}
              disableElevation
              disabled={actionLoading}
              className={classes.acceptButton}
              onClick={handleSubmit(AcceptOrderButtonPressed)}
              startIcon={
                <Grid className={classes.startIconStyle}>
                  {actionLoading ? (
                    <CircularProgress size="18px" style={{ color: "white" }} />
                  ) : (
                    <CheckRoundedIcon
                      style={{ fontSize: "18px", color: "white" }}
                    />
                  )}
                </Grid>
              }
            >
              {t("orderDetails.accept")}
            </Button>
          )
        )}
      </Grid>
    );
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <RejectOrderModal
          visible={rejectOrderModalVisible}
          onClose={() => setRejectOrderModalVisible(false)}
          onRejectButtonPressed={RejectOrderConfirmButtonPressed}
          data={data}
        />
        <NoItemLeftModal
          visible={noItemLeftModalVisible}
          onClose={NoItemLeftModalClose}
          onRejectOrderPressed={RejectOrderConfirmButtonPressed}
        />
        <RejectItemModal
          visible={rejectItemModalVisible}
          onClose={RejectItemModalClose}
          onRejectButtonPressed={RejectItemConfirmButtonPressed}
          orderLineQuantity={orderLineQuantity}
        />
        <ResolveDeliverySelectionModal
          visible={resolveDeliveryModalVisible}
          onClose={() => setResolveDeliveryModalVisible(false)}
          onResolveButtonPressed={ResolveDeliveryConfirmPressed}
        />
        <DeliveryAlreadyProcessedModal
          visible={alreadyProcessedModalVisible}
          onClose={() => window.location.reload()}
        />
        {orderDetailsLoading || data.length === 0 ? (
          <CircularProggressIndicator />
        ) : (
          <>
            <OrderDetailsHeaderSection
              data={data}
              onBackClicked={onBackClicked}
              onResolveButtonPress={ResolveButtonPressed}
              onRefund={RefundDeliveredDelivery}
              acceptLoading={actionLoading}
            />
            <Container className={classes.detailsContainer}>
              {!!data.Failed && (
                <OrderDetailsFailureWarning
                  reason={data.FailedReason || ""}
                  notes={data.FailedReasonNotes || ""}
                />
              )}
              {data?.DeliveryTrackingUrl?.length > 0 && renderTrackingInfo()}

              <OrderDetailsBasicInfoSection data={data} />
              {role === "Admin" && <OrderDetailsHistorySection data={data} />}
              <OrderDetailsCustomerInformationSection data={data} />

              {roleName() === "Admin" ? (
                <OrderDetailsMerchantInfoSection
                  data={merchantInfo}
                  shop={data.ShopName}
                />
              ) : null}
              {roleName() === "Admin" &&
              (data.Delivered || data.OutForDelivery) ? (
                <OrderDetailsDriverInfoSection
                  driverInfo={driverInfo}
                  deliveryDate={data.Delivered}
                />
              ) : null}
              <OrderDetailsOrderedItemsSection
                data={data}
                onPrintItemListClicked={PrintItemListClicked}
                rejectItemPressed={RejectItemButtonPressed}
                resetQuantityPressed={ResetQuantityPressed}
                loading={actionLoading}
              />
              {/*<OrderTotal
                data={data}
              />*/}

              {is_able_to("view_qr_printable_section") && (
                <Container className={classes.printableSection}>
                  <QRPrintableComponent
                    ref={qrSectionRef}
                    qrData={deliveryAcceptData}
                    data={data}
                  />
                </Container>
              )}
              {is_able_to("print_labels_again") && (
                <Container className={classes.printableSection}>
                  <PrintLabelsAgainComponent
                    ref={qrSectionPrintAgainRef}
                    data={data}
                    rePrintPackagesInfo={rePrintPackagesInfo}
                  />
                </Container>
              )}
              {is_able_to("view_printable_item_list") && (
                <Container className={classes.printableSection}>
                  <PrintableItemList ref={itemListRef} data={data} />
                </Container>
              )}

              {renderPickupInstructions()}
              {renderVehicleType()}
              {renderActionButtons()}
            </Container>
          </>
        )}
      </Container>
      <TrigerPrint
        print={print}
        printFunc={PrintLabels}
        printAgain={printAgain}
        printAgainFunc={PrintLabelsAgain}
        printItemList={printItemList}
        printItemListFunch={PrintItemList}
      />
      <NumberOfPackageSelectionModal
        visible={numberOfPackageModalVisible}
        onClose={() => setNumberOfPackageModalVisible(false)}
        onSubmit={(packages: any) => PackagesSelected(packages)}
      />
      <OrderCancelledModal
        visible={displayHasCancellationModal}
        orderCancelled={wholeDeliveryCancelled}
        acknowledgePressed={onAcknowledgePressed}
      />

      {showCheckErrorsModal()}
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    justifyContent: "center",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  printableSection: {
    display: "none",
  },
  acceptButton: {
    marginLeft: 8,
    borderRadius: 8,
    "&:hover": {
      backgroundColor: "rgba(58, 131, 86, 0.92) !important",
    },
    "&:active": {
      backgroundColor: "rgba(58, 131, 86, 0.76) !important",
    },
  },
  buttonIcon: {
    width: 18,
    height: 18,
    paddingRight: 5,
  },
  startIconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  actionButtonsContainer: {
    display: "flex",
    marginTop: "16px",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
});
const printablePageStyle = `
  @page {
    size: 80mm 80mm;
    margin: 0;
  }

  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }
  body { margin: 0cm; padding: 0cm; }
`;
